<template>
    <div class="app">
        <TopNav></TopNav>
        <div class="center">
            <!-- 新闻头部 -->
            <div class="news-hd">
            </div>
            <!-- 新闻底部模块 -->
            <div class="news-bd">
                <div class="content_row">
                    <div class="news-tip">
                        <h2>全部资讯</h2>
                    </div>
                    <div class="news-num">
                        <ul>
                            <li>
                                <img src="../assets/xw-pic1.png" alt="">
                                <h4>2022中央一号文件来了！</h4>
                                <p>2022年中央一号文件于2月22日正式发布。这份文件题为《中共中央国务院关于做好2022年全面推进乡村振兴重点工作的意见》，这是21世纪以来第19个指导“三农”工作的中央一号文件。
                                </p>
                                <router-link to="/news1">
                                    <span>了解更多</span>
                                </router-link>
                            </li>
                            <li>
                                <img src="../assets/xw-pic2.png" alt="">
                                <h4>图说调查报告：2021年农贸市场发展情况！</h4>
                                <p>全方面分析2021农贸市场发展情况，智慧化农贸市场迎来机遇与挑战！</p>
                                <router-link to="/news2">
                                    <span>了解更多</span>
                                </router-link>
                            </li>
                            <li>
                                <img src="../assets/al1.jpg" alt="">
                                <h4>西安市霖昌易购乐市场盛大开业！</h4>
                                <p>霖昌易购乐市场经过改造升级，5月20日盛大开业！开业当日，前来买菜的居民络绎不绝，升级后的市场，作为社区邻里中心，不仅汇集民生优惠，更凝聚着智慧高科技。
                                </p>
                                <a href="###"><span>了解更多</span></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <BottomNav></BottomNav>
    </div>
</template>

<script>
import TopNav from '../components/TopNav.vue'
import BottomNav from '../components/BottomNav.vue'
export default {
    components: { TopNav, BottomNav },
    data() {
        return {

        }
    },
    created() { },
    mounted() { },
    methods: {},
}
</script>

<style lang="less" scoped>
.app {
    width: 100vw;
    height: 100vh;
    background-size: cover;
    z-index: -1;
    overflow-x: hidden;
}

.center {
    width: 100%;
    min-height: calc(100vh - .8333rem - 5.9063rem);
    margin-top: .8333rem;
}

.content_row {
    width: 100%;
    height: 100%;
    padding: 0 4.25rem;
    box-sizing: border-box;
}

.title_content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.title_content .title {
    display: flex;
    align-items: center;
}

.title_content img {
    width: 1.1458rem;
    height: .2292rem;
}

.title_content h1 {
    font-size: .3958rem;
}

.title_content p {
    height: .3021rem;
    font-size: .2188rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232A24;
    line-height: .3021rem;
    margin-top: .2917rem;
}

.news-hd {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 5.2083rem;
    background: url(../assets/news-bj.png) no-repeat center;
    background-size: 100% 5.2083rem;
    margin-top: .8333rem;
    z-index: -1;
}

.news-bd {
    height: 10rem;
}

.news-bd .news-tip {
    overflow: hidden;
    color: #000;
    text-align: center;
    height: 1.7rem;
}

.news-bd .news-tip h2 {
    margin-top: 0.7rem;
    padding-bottom: 0.25rem;
    border-bottom: .0313rem solid #ccc;
}

.news-num ul li {
    position: relative;
    width: 100%;
    height: 2.2917rem;
    /* background-color: pink; */
    margin-bottom: .2083rem;
    box-shadow: 0px 0px .2604rem .0104rem rgba(35, 42, 36, 0.1);
}

.news-num ul li img {
    float: left;
    width: 4.0625rem;
    height: 2.2917rem;
    margin-right: .2083rem;
}

.news-num ul li h4 {

    overflow: hidden;
    color: #000;
    padding-top: .2083rem;
    margin-bottom: .2083rem;

}

.news-num ul li h4 p {
    margin-top: .3125rem;
    font-size: .1667rem;
    background-color: #ddd;
    padding-right: .3125rem;
}

.news-num ul li span {
    position: absolute;
    bottom: .2083rem;
    right: .5083rem;
    display: block;
    width: 1.5rem;
    padding: 0 .2704rem;
    height: .5208rem;
    line-height: .5208rem;
    border: 1px solid #08C667;
}

.news-num ul li span:hover {
    color: #fff;
    background-color: #08C667;
}
</style>